import React from "react";

const ReviewConfirmCourses = ({ onlineSessions }) => {
  const sortedSessions = (onlineSessions || []).sort(
    (a, b) => a.SequenceOrder - b.SequenceOrder
  );

  return (
    <div className="review-confirm-courses">
      {sortedSessions.length === 0 ? (
        <div className="no-data">No data found</div>
      ) : (
        sortedSessions.map((session) => (
          <div key={session.CourseId} className="course-row">
            <div className="course-hours">{session.Credits}h</div>
            <div className="course-name">{session.CourseName}</div>
          </div>
        ))
      )}
    </div>
  );
};

export default ReviewConfirmCourses;
